import { render, staticRenderFns } from "./product-item.vue?vue&type=template&id=509d99c4"
import script from "./product-item.vue?vue&type=script&lang=js"
export * from "./product-item.vue?vue&type=script&lang=js"
import style0 from "./product-item.vue?vue&type=style&index=0&id=509d99c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
